import { message } from "antd";
import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-type": "application/json",
    "Time-Zone":Intl.DateTimeFormat().resolvedOptions().timeZone
  },
});


const navigateToLogin = () => {
   sessionStorage.clear();
  window.location.href = "/";
};

http.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem("access_token");
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];
let hasShownSessionExpiredMessage = false;

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

http.interceptors.response.use((response) => response, async (error) => {
  const originalRequest = error.config;

  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    const refreshToken = sessionStorage.getItem('refresh_token');

    if (!isRefreshing) {
      isRefreshing = true;

      try {
        const response = await http.get(`/oauth/new/token?refreshToken=${refreshToken}`);
        if (response?.data?.error === "1") {
          processQueue(response.data, null);
          isRefreshing = false;

          if (!hasShownSessionExpiredMessage) {
            hasShownSessionExpiredMessage = true;
            message.warning({
              content: "Your session has ended. Please log in again to continue.",
              onClose: navigateToLogin,
            });
          }
          return Promise.reject(response.data);
        }
        const newToken = response?.data?.access_token;

        sessionStorage.setItem('access_token', newToken);
        http.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
        processQueue(null, newToken);
        isRefreshing = false;

        // Retry the original request with new token
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
        return http(originalRequest);
      } catch (err) {
        processQueue(err, null);
        isRefreshing = false;

        message.warning({
          content: "Your session has ended. Please log in again to continue.",
          onClose: navigateToLogin,
        });
        return Promise.reject(err);
      }
    }

    return new Promise(function (resolve, reject) {
      failedQueue.push({
        resolve: (token) => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          resolve(http(originalRequest));
        },
        reject: (err) => {
          reject(err);
        }
      });
    });
  }

  return Promise.reject(error);
}
);

export default http;
